import {
  HOME_COUNT_BY_EDU_BEGIN,
  HOME_COUNT_BY_EDU_SUCCESS,
  HOME_COUNT_BY_EDU_FAILURE,
  HOME_COUNT_BY_EDU_DISMISS_ERROR,
} from './constants';
import request from '../../../utils/request'
// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function countByEdu(args = {}) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: HOME_COUNT_BY_EDU_BEGIN,
    });
    const promise = new Promise((resolve, reject) => {
        request({
          method:'post',
          url:'/api/b/user/countByEdu',
        }).then( data => {
            dispatch({
                type: HOME_COUNT_BY_EDU_SUCCESS,
                data: data,
            });
            resolve(data);
        }).catch (error => {
            dispatch({
              type: HOME_COUNT_BY_EDU_FAILURE,
              data: { error: error },
            });
            reject(error);
        })
    });

    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissCountByEduError() {
  return {
    type: HOME_COUNT_BY_EDU_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_COUNT_BY_EDU_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        countByEduPending: true,
        countByEduError: null,
      };

    case HOME_COUNT_BY_EDU_SUCCESS:
      // The request is success
      return {
        ...state,
        countByEduPending: false,
        countByEduError: null,
        countByEdu:action.data,
      };

    case HOME_COUNT_BY_EDU_FAILURE:
      // The request is failed
      return {
        ...state,
        countByEduPending: false,
        countByEduError: action.data.error,
      };

    case HOME_COUNT_BY_EDU_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        countByEduError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/home/redux/countByEdu.js